import { render } from "./CreateOrder.vue?vue&type=template&id=0d54f024&scoped=true&bindings={\"goTo\":\"setup\",\"deleteLocal\":\"setup\",\"handleCreateOrder\":\"setup\",\"close\":\"setup\",\"handlePayOrder\":\"setup\",\"total\":\"setup\"}"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"

import "./CreateOrder.vue?vue&type=style&index=0&id=0d54f024&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0d54f024"

export default script